import { http } from "@/utils/request";

/**
 * 获取公司动态列表
 */
export const useGetDynamicListApi = async (params) => {
  console.log("公司动态接口-请求参数", params);
  const res = await http.post("/companyOfficialWebsite/siteNewsListForOut", params);
  console.log("公司动态接口-返回数据", res);
  return res;
};
